export function resizeSelection(value, label) {
  if (value === '') return null;
  return { to: value, label };
}

if (typeof customElements !== 'undefined' && !customElements.get('ring-resize-picker')) {
  customElements.define(
    'ring-resize-picker',
    class RingResizePicker extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-resize-select]');
        this.fromInput = this.querySelector('[data-resize-from]');
        this.toInput = this.querySelector('[data-resize-to]');
        this.labelInput = this.querySelector('[data-resize-label]');
        this.select.addEventListener('change', this.onChange.bind(this));
        this.onChange();
      }

      onChange() {
        const option = this.select.selectedOptions[0];
        const selection = resizeSelection(option.value, option.dataset.label);

        if (selection === null) {
          this.fromInput.disabled = true;
          this.toInput.disabled = true;
          this.labelInput.disabled = true;
          this.toInput.value = '';
          this.labelInput.value = '';
          return;
        }

        this.toInput.value = selection.to;
        this.labelInput.value = selection.label;
        this.fromInput.disabled = false;
        this.toInput.disabled = false;
        this.labelInput.disabled = false;
      }
    }
  );
}
